import api from '@/redux/api/page';
import { createSelector } from 'reselect';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';

/* Action Types */
export const LOAD_ABOUT_DATA_FAIL = 'la/domain/about/LOAD_FAIL';
export const LOAD_ABOUT_DATA_REQUEST = 'la/domain/about/LOAD_REQUEST';
export const LOAD_ABOUT_DATA_SUCCESS = 'la/domain/about/LOAD_SUCCESS';

// reducer
const DEFAULT_STATE = {};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: any = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.about;

const shouldFetchAboutData = createSelector(stateSelector, () => true);

/* ACTION CREATORS */
const loadAboutData = () => async (dispatch, getState) => {
    try {
        const state = getState();
        const deployment = getDeployment(state);
        dispatch({
            type: LOAD_ABOUT_DATA_REQUEST,
        });
        const response = await api.fetchAboutData({ deployment });
        return dispatch({
            meta: { actionTime: Date.now() },
            payload: response.data,
            type: LOAD_ABOUT_DATA_SUCCESS,
        });
    } catch (error) {
        return dispatch({
            error: true,
            payload: error,
            type: LOAD_ABOUT_DATA_FAIL,
        });
    }
};

export const fetchAboutDataIfNeeded = () => async (dispatch: Function, getState: Function) => {
    if (shouldFetchAboutData(getState())) {
        return dispatch(loadAboutData());
    }
    return Promise.resolve();
};
